/**
 * Причины снятия позиции.
 *
 * Снятое блюдо — не мелочь: за ним либо испорченный продукт, либо
 * ошибка человека, либо недовольный гость. Без причины все три случая
 * выглядят одинаково, и владелец не поймёт, теряет он на браке кухни
 * или на невнимательности официантов.
 *
 * Список закрытый и короткий: длинный никто не читает, а выбирают
 * первый пункт. Каждая причина отвечает на вопрос «кто виноват
 * и что делать», а не просто описывает событие.
 */

export type VoidReason =
  | 'WAITER_MISTAKE'
  | 'GUEST_REFUSED'
  | 'QUALITY'
  | 'DISCOUNT_ERROR'
  | 'OTHER';

export const VOID_REASONS: { key: VoidReason; label: string; hint: string }[] = [
  {
    key: 'WAITER_MISTAKE',
    label: 'Ошибка официанта',
    hint: 'пробил не то блюдо или не на тот стол',
  },
  {
    key: 'GUEST_REFUSED',
    label: 'Гость отказался',
    hint: 'передумал до подачи',
  },
  {
    key: 'QUALITY',
    label: 'Низкое качество',
    hint: 'блюдо не приняли: пережарено, холодное, не то',
  },
  {
    key: 'DISCOUNT_ERROR',
    label: 'Ошибка со скидкой',
    hint: 'пересобрать позицию с верной ценой',
  },
  {
    key: 'OTHER',
    label: 'Другое',
    hint: 'опишите словами — это попадёт в журнал',
  },
];

/** Подпись причины для чека, отчёта и журнала. */
export function voidReasonLabel(key: VoidReason): string {
  return VOID_REASONS.find((r) => r.key === key)?.label ?? 'Другое';
}

/**
 * Требует ли причина пояснения словами.
 *
 * «Другое» без пояснения бессмысленно. «Низкое качество» тоже стоит
 * пояснить: повару нужно знать, что именно не так, иначе он повторит.
 */
export function needsComment(key: VoidReason): boolean {
  return key === 'OTHER' || key === 'QUALITY';
}

/**
 * Ложится ли снятие на кухню.
 *
 * Если блюдо уже готовили, продукты потрачены — и списание должно
 * дойти до склада. Отказ гостя до подачи такого следа не оставляет.
 */
export function hitsKitchen(key: VoidReason, wasFired: boolean): boolean {
  if (!wasFired) return false;
  return key === 'QUALITY' || key === 'WAITER_MISTAKE';
}
